import { Component, Input, OnChanges } from '@angular/core';

import { InsurancePlanAccumulators, InsurancePlanAccumulatorsCoverage } from '@genesis-frontend/graphql';

@Component({
    selector: 'dental-accumulators',
    templateUrl: 'dental-accumulators.component.html',
    styleUrls: ['../../insurance-plan-coverage.component.scss']
})
export class DentalAccumulatorsComponent implements OnChanges {
    @Input() dentalAccumulators: InsurancePlanAccumulators | undefined = {} as InsurancePlanAccumulators;

    accumulatorData: InsurancePlanAccumulatorsCoverage[] = [];
    individualDeductible: InsurancePlanAccumulatorsCoverage | undefined;
    familyDeductible: InsurancePlanAccumulatorsCoverage | undefined;
    annualMax: InsurancePlanAccumulatorsCoverage | undefined;

    readonly constants = {
        PLAN_LEVEL_INDIVIDUAL: 'Individual',
        PLAN_LEVEL_FAMILY: 'Family',
        INDIVIDUAL_DEDUCTIBLE: 'InNetworkIndividualDeductible',
        FAMILY_DEDUCTIBLE: 'InNetworkFamilyDeductible',
        INDIVIDUAL_OOPM: 'InNetworkIndividualOopm',
        FAMILY_OOPM: 'InNetworkFamilyOopm',
        DATE_FORMAT: 'MMMM dd, yyyy'
    };

    ngOnChanges() {
        this.accumulatorData = this.mapAccumulators();
        this.individualDeductible = this.findAccumulator(this.constants.INDIVIDUAL_DEDUCTIBLE);
        this.familyDeductible = this.findAccumulator(this.constants.FAMILY_DEDUCTIBLE);
        this.annualMax = this.findAccumulator(this.constants.INDIVIDUAL_OOPM)
            ?? this.findAccumulator(this.constants.FAMILY_OOPM);
    }

    mapAccumulators(): InsurancePlanAccumulatorsCoverage[] {
        return (this.dentalAccumulators?.accumulatorData || []).filter((data): data is InsurancePlanAccumulatorsCoverage => data != null);
    }

    findAccumulator(accumulatorName: string): InsurancePlanAccumulatorsCoverage | undefined {
        return this.accumulatorData.find((accumulator) => accumulator.accumulatorName === accumulatorName);
    }
}
